import { render, staticRenderFns } from "./VerticalNavMenuCurrentClub.vue?vue&type=template&id=9f72dbf0&"
import script from "./VerticalNavMenuCurrentClub.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuCurrentClub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
